import api from "./api";

export default {
  get(id) {
    return api.get(`player/${id}`);
  },
  getAll() {
    return api.get("players");
  },
  update({ id, data }) {
    return api.put(`player/${id}`, data);
  },
  create({ id, data }) {
    return api.post(`player/${id}`, data);
  }
};
